/* eslint-disable no-useless-escape */
export default {
  validEmail: (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid',
  noSpecialChar: (v) => !v || /^[A-Za-z0-9 ]+$/.test(v) || 'Only letters and numbers are accepted',
  charsOnly: (v) => !v || /^[a-zA-Z ]+$/.test(v) || 'Only letters are accepted',
  phone: (v) => (v || '').length == 0 || /^[\d+]+$/.test(v) || 'Phone must be valid',
  length: (len) => (v) => (v || '').length >= len || `More than ${len} characters is required!`,
  lengthMax: (len) => (v) =>
    (v || '').length <= len || `More than ${len} characters is NOT allowed!`,
  lengthExact: (len) => (v) =>
    (v || '').length == len || (v || '').length == 0 || `Only ${len} characters is valid!`,
  number: (v) =>
    /^([0-9]*.[0-9]+|[0-9]+)$/.test(v) || (v || '').length == 0 || 'Only numbers are valid',
  feet: (v) =>
    (v || '').length > 12
      ? 'You exceed maximum number'
      : /^[\d\s'"/.]+$/.test(v) ||
        (v || '').length == 0 ||
        'Only numbers and special characters are valid',
  ip: (v) => /^(\d{1,3}\.){3}\d{1,3}$/.test(v) || 'Invalid ip address',
  numberFF: (v) => /^([0-9]*.[0-9]+|[0-9]+)$/.test(v) || '' || 'Only numbers are valid', //for firefox
  // number: (v) =>
  //   /^[0-9]+.[0-9]+|[0-9]+$/.test(v) || (v || "").length == 0 || "Only numbers are valid",
  numberMin: (min) => (v) => (v || '') >= min || `Minimum number is ${min}!`,
  numberMax: (max) => (v) => (v || '') <= max || `Maximum number is ${max}!`,
  isClientAbbr: (v) =>
    /^[0-9A-Z\.\_\-]{2,10}$/.test(v) ||
    (v || '').length == 0 ||
    'Range [2 - 10] of Capital Letters, Numbers, or . _ - are valid',
  usPostalCode: (v) => /^[0-9]{5}$/i.test(v) || (v || '').length == 0 || 'Invalid US Postal Code',
  mexicoPostalCode: (v) =>
    /^[0-9]{5}$/i.test(v) || (v || '').length == 0 || 'Invalid Mexican Postal Code',
  canadaPostalCode: (v) =>
    /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i.test(v) ||
    (v || '').length == 0 ||
    'Invalid Canadian Postal Code',
  polandPostalCode: (v) =>
    /^[0-9]{2}-[0-9]{3}$|^[0-9]{5}$/i.test(v) ||
    (v || '').length == 0 ||
    'Invalid Polish Postal Code',
  password: (v) =>
    !!(v || '').match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*(_|[^\w])).+$/) ||
    'Password must contains at least: a capital letter, a small letter, a number & a special character!',
  required: (v) => {
    return (v && String(v).trim() !== '') || 'This field is required!';
  },
  requiredNumber: (v) =>
    (v !== null && String(v).trim() !== '') || v === 0 || 'This field is required!',
  confirmPassword: (value, password) => {
    return value === password || "Password doesn't match";
  },
  emailRules: [
    (v) => !!v || 'E-mail is required',
    (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'E-mail must be valid',
  ],
  arrayNotEmpty: (v) => (v || []).length > 0 || `Select at least one!`,
  url: (v) =>
    new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR IP (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i',
    ).test(v) ||
    (v || '').length == 0 ||
    'Invalid URL!',
  urlForced: (v) =>
    /^(https?:\/\/(?:www\.)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(?:[\?])*(.+)*)$/.test(
      v,
    ) || 'Invalid URL!',
};
